// src/app/features/campañas/component/modal-add-tokens.component.ts

import {Component, EventEmitter, Output} from '@angular/core';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'app-modal-add-tokens',
  // Asegúrate de que esta línea esté presente y sea 'true'
  standalone: true,
  imports: [CommonModule],
  // Asegúrate de que este archivo exista en la misma carpeta
  templateUrl: './modal-add-tokens.component.html',
  styleUrls: ['./modal-add-tokens.component.scss']
})
export class ModalAddTokensComponent {
  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  onConfirm() {
    this.confirm.emit();
  }

  onCancel() {
    this.cancel.emit();
  }
}
